module.exports = __webpack_public_path__ + "media/images/gallery/stars/aquila/altair_vis-b9da95d79d4d46d76744c5c625ec15ff.jpg";